import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';

import { connect } from 'react-redux';
import { UtilityButtonDefault as ReviewButton } from 'ecs-react-components/dist/index.es';
import { messages } from './Questionnaires.i18n';
import { questionnaireSelected }
  from '../../redux/modules/questionnaires/questionnaires-action-creator';
import history from '../../history';

class QuestionnaireCardHistory extends React.Component {
  onReviewButtonClick = () => {
    this.props.dispatch(questionnaireSelected(this.props.item.assignedQuestionnaireId));
    history.push('/review-questionnaire');
  };

  renderDateTitle() {
    if (this.props.item.statusDescription === 'Completed') {
      return messages.date.completed;
    }
    if (this.props.item.statusDescription === 'Declined') {
      return messages.date.declined;
    }
    if (this.props.item.statusDescription === 'Missed') {
      return messages.date.missed;
    }
    return '';
  }

  render() {
    return (
      <div key={ this.props.item.assignedQuestionnaireId }>
        <div className="row">
          <div className="col-lg-6 col-12">
            <div data-qa-item={ this.props.item.assignedQuestionnaireId }
              className="panel panel-default description-box"
            >
            <Card bg="white">
              <Card.Body className="new-indicator-padding-left">
                {this.props.item.statusDescription === 'Completed'
                  ? <ReviewButton buttonName={messages.button.review}
                      onClick={this.onReviewButtonClick}
                  /> : null }
                <p>
                  <span className="title">{this.props.item.templateTitle}</span>
                  <br />
                    <span className="date">
                    <FormattedMessage {...this.renderDateTitle()} />
                    {moment(this.props.item.completedDate).format('MMM DD, YYYY')}
                    </span>
                </p>
                <p>{this.props.item.templateDescription}</p>
              </Card.Body>
            </Card>
            </div>
          </div>
        </div>
        <div className="spacer tiny" />
        <div className="spacer small" />
      </div>
    );
  }
}

QuestionnaireCardHistory.propTypes = {
  dispatch: PropTypes.func,
  item: PropTypes.object,
};

export default connect()(QuestionnaireCardHistory);